import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { WarrantyIssueInfo } from '../fragments';

export default gql`
  mutation createWarrantyIssue($input: WarrantyIssueCreateInput!) {
    createWarrantyIssue(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      warrantyIssue {
        ...WarrantyIssueInfo
      }
    }
  }
  ${WarrantyIssueInfo}
  ${ErrorMessageInfo}
`;
